const main = () => {
    if (document.querySelector('#page-sold-result') === null) return;
    const searchType = document.querySelector(".pg-header__search-type select");
    if (searchType) {
        searchType.addEventListener("change", (e) => {
            e.currentTarget.closest("form").submit();
        });
    }
}

export default main;